import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import { useCallback, useState, useRef } from 'react';
import 'survey-core/defaultV2.min.css';
import { Model } from 'survey-core';
import "survey-core/survey.i18n";
import { Survey } from 'survey-react-ui';
import {surveyJson} from './surveyDataVer1.js';
import {themeJson} from './theme.js';
import { Serializer } from "survey-core";
import Result from './pages/result.js';
import { useNavigate } from 'react-router-dom';


import './App.css';


Serializer.addProperty("itemvalue", {
  name: "score:number",
});
Serializer.addProperty("itemvalue", {
  name: "threat:string",
});
function SurveyComponent() {
  const survey = new Model(surveyJson);
  const navigate = useNavigate();
  survey.locale = "es";
  // You can delete the line below if you do not use a customized theme
  survey.applyTheme(themeJson);
  
  
  survey.onComplete.add((sender, options) => {

      //Add each question score to survey results
      let data = sender.data;
      sender.getAllQuestions().forEach((question) => {
        const qValue = question.value;
        console.log(question.choices)
        console.log(qValue)
        //console.log(question.choices)
        if (question.choices) {
          const selectedChoice = question.choices.find(choice => choice.value === qValue);
          if (selectedChoice) {
            //console.log(question.name);
            //console.log(selectedChoice.score);
            data[question.name]={'score':selectedChoice.score,'value':qValue};
          }
          //multiple choices
          if (question.getType() === "checkbox") {
            const selectedChoices = question.choices.filter(choice => qValue.includes(choice.value));
            if (selectedChoices) {
              let score = 0;
              selectedChoices.forEach((choice) => {
                score += choice.score;
              });
              data[question.name]=selectedChoices
            }
          }
        }
        if (question.rateValues) {
          const selectedRate = question.rateValues.find(rate => rate.value === qValue);
          if (selectedRate) {
            data[question.name]={'score':selectedRate.score,'value':qValue};
          }
        }
      });



      
      data.timestamp = new Date().toISOString();
      data.uuid =Math.random().toString(36).substr(2, 9);
      data.userAgent = navigator.userAgent;
      console.log(JSON.stringify(data, null, 3));
      options.showSaveInProgress();
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "https://juegofde.com/api/submit-survey");
      xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
      xhr.onload = xhr.onerror = function () {
        if (xhr.status == 200 || xhr.status == 201) {
          // Display the "Success" message (pass a string value to display a custom message)
          options.showSaveSuccess();
          let threadUniqueValsStr = [...new Set(data.threat)].join(',');
          navigate('/result?riesgo='+threadUniqueValsStr+'&score='+data.totalScore);
          // Alternatively, you can clear all messages:
          // options.clearSaveMessages();
        } else {
          // Display the "Error" message (pass a string value to display a custom message)
          options.showSaveError();
        }
      };
      xhr.send(JSON.stringify(data));
      
      //history.push('/result?riesgo='+data.riesgo+'&score='+data.score);
  });
  function calculateMaxScore(questions) {
    var maxScore = 0;
    questions.forEach((question) => {
      if (question.choices) {
        const maxValue = Math.max.apply( Math, question.choices.map(o => o.score) );
        maxScore += maxValue;
        //checkbox
        //if (question.getType() === "checkbox") {
        //  const maxCheckboxValue = Math.max.apply( Math, question.choices.map(o => o.score) ) * question.choices.length;
        //  maxScore += maxCheckboxValue;
        //}
      }
      if (question.rateValues) {
        const maxValue = Math.max.apply( Math, question.rateValues.map(o => o.score) );
        maxScore += maxValue;
      }
      if (question.getType() === "matrix") {
        const maxMatrixValue = Math.max.apply( Math, question.columns.map(o => o.score) ) * question.rows.length;
        maxScore += maxMatrixValue;
      }
    });
    return maxScore;
  } 
  function calculateTotalScore(data) {
    var totalScore = 0;
    var threat = [];
    data.forEach((item) => {
      const question = survey.getQuestionByValueName(item.name);
      const qValue = item.value;
      if (question.choices) {
        const selectedChoice = question.choices.find(choice => choice.value === qValue);
        if (selectedChoice) {
          totalScore += selectedChoice.score;
          if(selectedChoice.threat){
            threat.push(selectedChoice.threat);
          }
        }
        //multiple choices
        if (question.getType() === "checkbox") {
          const selectedChoices = question.choices.filter(choice => qValue.includes(choice.value));
          if (selectedChoices) {
            let score = 0;
            selectedChoices.forEach((choice) => {
              score += choice.score;
              if(choice.threat){
                threat.push(choice.threat);
              }
            });
            totalScore += score;
          }
        }
      }
      if (question.rateValues) {
        const selectedRate = question.rateValues.find(rate => rate.value === qValue);
        if (selectedRate) {
          totalScore += selectedRate.score;
          if(selectedRate.threat){
            threat.push(selectedRate.threat);
          }
        }
      }
      if (question.getType() === "matrix") {
        item.data.forEach((dataItem) => {
          if (!!dataItem.value) {
            totalScore += dataItem.score;
          }
        });
      }
    });
    return {'score':totalScore,'threat':threat};
  }
  survey.onCompleting.add((sender) => {  
    const maxScore = calculateMaxScore(sender.getAllQuestions());
    // Get survey results as a flat data array
    const plainData = sender.getPlainData({
      // Include `score` values into the data array
      calculations: [{ propertyName: "score" }, { propertyName: "threat" }]
    });
    const totalScore = calculateTotalScore(plainData);

    // Save the scores in survey results
    let totalScoreAvrg = (totalScore.score/maxScore*100).toFixed(0);
    sender.setValue("maxScore", maxScore);
    sender.setValue("totalScore", Math.min(totalScoreAvrg,94));
    sender.setValue("threat", totalScore.threat);
  });
  return (<Survey model={survey} />);
}


function App() {
  //print in console the surveyJson
  console.log(surveyJson);
  // useRef enables the Model object to persist between state changes
  const survey = useRef(new Model(surveyJson)).current;
  const [surveyResults, setSurveyResults] = useState("");
  const [isSurveyCompleted, setIsSurveyCompleted] = useState(false);

  const displayResults = useCallback((sender) => {
    setSurveyResults(JSON.stringify(sender.data, null, 4));
    setIsSurveyCompleted(true);
  }, []);

  survey.onComplete.add(displayResults);

  return <div>  
    <Routes>
      <Route path="/" element={<SurveyComponent />}>
      </Route>
      <Route path="/result" element={<Result/>}/>
    </Routes>
  </div>
   
  return (
    <>
      <Survey model={survey} id="surveyContainer" />
      {isSurveyCompleted && (
        <>
          <p>Result JSON:</p>
          <code style={{ whiteSpace: 'pre' }}>
            {surveyResults}
          </code>
        </>
        )
      }
    </>
  );
}

export default App;
